import React, { useEffect } from 'react';
import WaitingForIncidentMessage from '../shared/IncidentWidgets/WaitingForIncidentMessage';
import { connect } from 'react-redux';
import { selectCurrentDisplayedIncident } from '../../../../state/modules/incidents/selectors';
import { IncidentContainer } from '../../../general/UnderstaffingWarning';

const IncidentCrewingWarnings = props => {
  useEffect(() => {
    props.dashboardAPIManager.fetchSkills();
    props.dashboardAPIManager.fetchGroupAndSubgroups(props.groupId);
  }, []);

  const incident = props.displayedIncident;
  const group = props.groups.byId[props.groupId];
  if (!group || !props.skills.lastFetch || !incident) return <WaitingForIncidentMessage />;

  return (
    <IncidentContainer
      key={incident.id}
      incident={incident}
      skills={props.skills}
      groups={[group]}
      hideHeader={true}
      showAllStatuses={true}
    />
  );
};

const mapStateToProps = state => ({
  displayedIncident: selectCurrentDisplayedIncident(state),
  groups: state.groups,
  skills: state.skills
});

export default connect(mapStateToProps)(IncidentCrewingWarnings);
